import * as React from "react";
import styled, { css } from "styled-components";
import groupBy from "lodash/groupBy";
import { Spoiler } from "components/common";
import { defaultCompare } from "logic/DefaultCompare";
const Container = styled.div`
  margin-top: 10px;
  max-height: 500px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const TableContainer = styled.div(
  ({ theme, $isSimilarFieldsTable }) => css`
    background-color: ${$isSimilarFieldsTable ? theme.colors.table.highlightBackground : theme.colors.section.filled.background};
    color: ${$isSimilarFieldsTable ? theme.colors.table.highlightText : "inherit"};
    padding: 5px;
    border-radius: 4px;
  `
);
const Table = styled.table`
  width: 100%;
  table-layout: fixed;
`;
const Header = styled.div(
  ({ theme }) => css`
    position: sticky;
    background-color: ${theme.colors.cards.background};
    top: 0;
    z-index: 1;
    margin-bottom: 2px;
  `
);
const FieldRow = styled.tr(
  ({ theme, $isSimilarFieldsTable }) => css`
    &:not(:last-child) {
      border-bottom: 1px solid ${$isSimilarFieldsTable ? theme.colors.table.highlightBorder : theme.colors.misc.divider};
    }

    td {
      padding: 5px;
    }
  `
);
const StyledSpoiler = styled(Spoiler)`
  word-break: break-word;
`;
const FieldName = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`;
const FieldsTable = ({ fields, isSimilarFieldsTable = false, renderFieldValue }) => /* @__PURE__ */ React.createElement(TableContainer, { $isSimilarFieldsTable: isSimilarFieldsTable }, /* @__PURE__ */ React.createElement(Table, null, /* @__PURE__ */ React.createElement("tbody", null, fields.map(([fieldName, fieldValue]) => /* @__PURE__ */ React.createElement(FieldRow, { key: fieldName, $isSimilarFieldsTable: isSimilarFieldsTable }, /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement("b", null, /* @__PURE__ */ React.createElement(FieldName, { title: fieldName }, fieldName)), /* @__PURE__ */ React.createElement(StyledSpoiler, { maxHeight: 20, showLabel: "Show more", hideLabel: "Hide" }, renderFieldValue(fieldName, fieldValue))))))));
const EvidenceFields = ({
  fields,
  similarFieldsFilterValue,
  renderFieldValue = (_, fieldValue) => fieldValue
}) => {
  var _a, _b;
  const groupedFields = groupBy(
    Object.entries(fields),
    ([fieldName]) => similarFieldsFilterValue.includes(fieldName) ? "similar" : "other"
  );
  const sortedSimilarFields = ((_a = groupedFields.similar) != null ? _a : []).sort(([name1], [name2]) => defaultCompare(name1, name2));
  const sortedOtherFields = ((_b = groupedFields.other) != null ? _b : []).sort(([name1], [name2]) => defaultCompare(name1, name2));
  return /* @__PURE__ */ React.createElement(Container, null, !!sortedSimilarFields.length && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Header, null, "Similar fields"), /* @__PURE__ */ React.createElement(FieldsTable, { fields: sortedSimilarFields, renderFieldValue, isSimilarFieldsTable: true })), !!sortedOtherFields.length && /* @__PURE__ */ React.createElement("div", null, !!sortedSimilarFields.length && !!sortedOtherFields.length && /* @__PURE__ */ React.createElement(Header, null, "Other fields"), /* @__PURE__ */ React.createElement(FieldsTable, { fields: sortedOtherFields, renderFieldValue })));
};
export default EvidenceFields;
